import React, { useEffect, useState } from "react";
import {
  Typography,
  Grid,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  CircularProgress,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useMessage } from "../../context/message-context";
import { useLocalStorage } from "../../utils/hooks";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";
import { ContentCopy } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

function ProfileLohnDetails(props) {
  const { t } = useTranslation();
  const { daten } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [lohnDaten, setLohnDaten] = useState([]);
  const [priv] = useLocalStorage(LOCAL_STORAGE_KEY.private);
  const { showErrorMessage, showSuccessMessage } = useMessage();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    setLohnDaten(daten);
  }, [daten]);

  const handleCopy = (copyData) => {
    navigator.clipboard.writeText(copyData);
    showSuccessMessage("Kopieren erfolgreich");
  };

  return (
    <>
      {isLoading ? (
        <Grid item xs={12}>
          <CircularProgress />
        </Grid>
      ) : (
        <Grid item>
          <Grid container spacing={0.5}>
            <Grid item xs={12}>
              <Paper>
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow key="lohndaten">
                        <TableCell width="70%">
                          <Typography>{t("Lohndaten")}</Typography>
                        </TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {Object.entries(lohnDaten).map(([item, index]) => {
                        return (
                          <TableRow key={item + index}>
                            <TableCell>
                              <Typography>{t(item)}</Typography>
                              {fullScreen && (
                                <Typography variant="body2">{index}</Typography>
                              )}
                            </TableCell>
                            <TableCell align="right">
                              {!fullScreen && (
                                <Typography variant="body2">{index}</Typography>
                              )}
                            </TableCell>
                            <TableCell align="right">
                              {index.length > 5 &&
                                index !== "Private Krankenkasse" && (
                                  <IconButton
                                    color="primary"
                                    onClick={() => handleCopy(index)}
                                  >
                                    <ContentCopy />
                                  </IconButton>
                                )}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
}

export default ProfileLohnDetails;
